module.exports = __webpack_public_path__ + "media/images/shapes/shape-4-b78ef256b0b4a02c4361704e15fccc88.svg";